exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper[data-v-d3ee3712] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  height: 100vh;\n  background: #ff847b;\n  color: white;\n}\n.icon[data-v-d3ee3712] {\n  font-size: 45px;\n  margin: 5px;\n}\n.link[data-v-d3ee3712] {\n  text-decoration: underline;\n  cursor: pointer;\n}\n.row[data-v-d3ee3712] {\n  -ms-flex-pack: center;\n      justify-content: center;\n  text-align: center;\n}\ndiv[data-v-d3ee3712] {\n  text-align: center;\n  line-height: 25px;\n}\ndiv > *[data-v-d3ee3712] {\n  width: 100%;\n}\n", ""]);

// exports
